import { Job } from '@portals/jobs/src/models/job';

import { ErrorPage } from './error-page';
import { FlexFooter } from './flex-footer';
import { Footer } from './footer';
import { Header } from './header';
import { InternArticleMeta } from './intern/articleMeta';
import { InternCanonical } from './intern/canonical';
import { InternMeta } from './intern/meta';
import { InternSocialMeta } from './intern/social-meta';
import { LegalFooter } from './legal-footer';
import { QuickNavi } from './quick-navi';
import { RedirectPage } from './redirect-page';
import { SiteSearchCategory } from './site-search-category';
import { Tag } from './tag';
import { UserContext } from './user-context';

/**
 * Model definition for page
 */
export interface Page {
  __contentType: 'page';
  id: string;
  publication_id?: number;
  slugName?: string;
  slugPath?: string;
  name?: string;
  type?: 'information' | 'guidance' | 'conversion';
  meta?: InternMeta;
  canonical?: InternCanonical;
  articleMeta?: InternArticleMeta;
  socialMeta?: InternSocialMeta;
  parent?: Page;
  children?: Page[];
  error_children?: ErrorPage[];
  header?: Header;
  quick_navi?: QuickNavi;
  content?: unknown[];
  footer?: Footer;
  flex_footer?: FlexFooter;
  legal_footer?: LegalFooter;
  redirect_children?: RedirectPage[];
  redirect_pages?: RedirectPage[];
  error_pages?: ErrorPage[];
  tags?: Tag[];
  ignoreInBreadcrumb?: boolean;
  published_first_at?: string;
  published_at?: string;
  site_search_category?: SiteSearchCategory;
  pageViewUserContext?: UserContext[];
  // Provided by injection
  parents: Pick<Page, 'id' | 'slugPath' | 'ignoreInBreadcrumb' | 'name'>[];
  jobData: {
    jobs: {
      item: Job;
    };
  };
}

export function isPage(obj: { __contentType?: string }): obj is Page {
  return obj.__contentType === 'page';
}
